export function preventDefault(event) {
    event.preventDefault();
}